<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="M16 12V7c0-.55-.45-1-1-1h-2V2h-2v4H9c-.55 0-1 .45-1 1v5H7v9c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-9h-1V8h4v4h-1v9c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-9h-1Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
